<div class="dash">

  <!-- Hero. The numbers are patched in by IndexState once /admin/stats
       resolves; the markup ships with em dashes rather than zeros, because a
       "0" that later turns into "31" was a lie for as long as it was on
       screen. -->
  <section class="greeting">
    <svg class="greeting__contours" viewBox="0 0 900 320" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <g fill="none" stroke="#D6C59D" stroke-width="1.4" stroke-linecap="round" opacity="0.20">
        <path d="M-40 230 Q220 175 470 230 T1000 215" />
        <path d="M-40 268 Q220 213 470 268 T1000 253" />
        <path d="M-40 306 Q220 251 470 306 T1000 291" />
      </g>
      <g fill="none" stroke="#6A8A76" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" opacity="0.26">
        <path d="M520 150 L640 70 L710 110 L820 30 L1000 150" />
      </g>
    </svg>
    <div>
      <p class="greeting__eyebrow"><%= _lcs( 'BELTURO Plattform' ) %></p>
      <h2 class="greeting__title"><%= _lcs( 'Übersicht.' ) %> <em data-id="hero-headline"><%= _lcs( 'Alle Tenants auf einen Blick.' ) %></em></h2>
      <p class="greeting__sub" data-id="hero-sub"><%= _lcs( 'Kennzahlen zu Gastgebern, Unterkünften und den regionalen Inhalten, die allen Gästemappen zugrunde liegen.' ) %></p>
    </div>
    <div class="greeting__actions">
      <button class="dbtn dbtn--accent" type="button" data-route="/sources"><i class="icon icon--layers"></i> <%= _lcs( 'Datenquellen' ) %></button>
    </div>
  </section>

  <!-- Loading / error state. Replaces the body below, never the hero, so a
       failed load still leaves the page's heading and its way out. -->
  <div class="dash-msg" data-id="msg" hidden>
    <span class="dash-msg__icon"><i class="icon icon--layout-dashboard" data-id="msg-icon"></i></span>
    <h2 data-id="msg-title"><%= _lcs( 'Lade Kennzahlen …' ) %></h2>
    <p data-id="msg-text"><%= _lcs( 'Einen Moment bitte.' ) %></p>
  </div>

  <div data-id="body" hidden>

    <!-- ===== KPI row ===== -->
    <section class="kpi-grid">
      <div class="kpi">
        <div class="kpi__top">
          <span class="kpi__label"><%= _lcs( 'Gastgeber' ) %></span>
          <span class="kpi__icon"><i class="icon icon--briefcase"></i></span>
        </div>
        <div class="kpi__value" data-id="kpi-clients">—</div>
        <span class="kpi__delta kpi__delta--flat" data-id="kpi-clients-sub">
          <i class="icon icon--user-round"></i> <span>—</span>
        </span>
      </div>

      <div class="kpi">
        <div class="kpi__top">
          <span class="kpi__label"><%= _lcs( 'Unterkünfte' ) %></span>
          <span class="kpi__icon"><i class="icon icon--building-2"></i></span>
        </div>
        <div class="kpi__value" data-id="kpi-accommodations">—</div>
        <span class="kpi__delta kpi__delta--flat" data-id="kpi-accommodations-sub">
          <i class="icon icon--circle-check"></i> <span>—</span>
        </span>
      </div>

      <div class="kpi">
        <div class="kpi__top">
          <span class="kpi__label"><%= _lcs( 'Gästekonten' ) %></span>
          <span class="kpi__icon kpi__icon--sky"><i class="icon icon--users"></i></span>
        </div>
        <div class="kpi__value" data-id="kpi-guests">—</div>
        <span class="kpi__delta kpi__delta--flat" data-id="kpi-guests-sub">
          <i class="icon icon--user-round"></i> <span>—</span>
        </span>
      </div>

      <div class="kpi">
        <div class="kpi__top">
          <span class="kpi__label"><%= _lcs( 'Datenquellen' ) %></span>
          <span class="kpi__icon kpi__icon--sand"><i class="icon icon--layers"></i></span>
        </div>
        <div class="kpi__value" data-id="kpi-sources">—</div>
        <span class="kpi__delta kpi__delta--flat" data-id="kpi-sources-sub">
          <i class="icon icon--plug-zap"></i> <span>—</span>
        </span>
      </div>
    </section>

    <!-- ===== Charts + lists ===== -->
    <section class="dash-cols" style="margin-top: var(--space-6);">

      <!-- Left column -->
      <div class="dash-col">

        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--bar-chart-3"></i> <%= _lcs( 'Regionale Inhalte' ) %></h3>
            <span class="widget__note"><%= _lcs( 'Plattform-Pool, ohne Duplikate' ) %></span>
          </div>
          <div class="widget__body">
            <div class="chart chart--content" data-id="chart-content"></div>
          </div>
        </div>

        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--layers"></i> <%= _lcs( 'Datenquellen' ) %></h3>
            <button class="widget__link" type="button" data-route="/sources"><%= _lcs( 'Verwalten' ) %> <i class="icon icon--arrow-right"></i></button>
          </div>
          <div class="widget__body widget__body--flush">
            <div class="srclist" data-id="srclist"></div>
          </div>
        </div>

      </div>

      <!-- Right column -->
      <div class="dash-col">

        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--map-pinned"></i> <%= _lcs( 'Verteilung' ) %></h3>
          </div>
          <div class="widget__body">
            <div class="chart chart--mix" data-id="chart-mix"></div>
          </div>
        </div>

        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--users"></i> <%= _lcs( 'Konten' ) %></h3>
          </div>
          <div class="widget__body">
            <div class="acct">
              <div>
                <div class="acct__row">
                  <span class="acct__label"><%= _lcs( 'Unterkünfte veröffentlicht' ) %></span>
                  <span class="acct__value" data-id="acct-published">—</span>
                </div>
                <div class="acct__bar"><span data-id="acct-published-bar" style="width: 0%;"></span></div>
                <div class="acct__legend">
                  <span data-id="acct-published-legend">—</span>
                  <span data-id="acct-draft-legend">—</span>
                </div>
              </div>

              <div class="acct__row">
                <span class="acct__label"><%= _lcs( 'Gastgeber (Client-Rolle)' ) %></span>
                <span class="acct__value" data-id="acct-clients">—</span>
              </div>
              <div class="acct__row">
                <span class="acct__label"><%= _lcs( 'Gästekonten' ) %></span>
                <span class="acct__value" data-id="acct-guests">—</span>
              </div>
              <div class="acct__row">
                <span class="acct__label"><%= _lcs( 'Plattform-Administratoren' ) %></span>
                <span class="acct__value" data-id="acct-admins">—</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Vertex AI spend, platform-wide. Months are filled in by
             IndexState.renderAiCosts from stats.ai. -->
        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--sparkles"></i> <%= _lcs( 'KI-Kosten' ) %></h3>
            <span class="widget__note"><%= _lcs( 'Vertex AI · letzte 3 Monate' ) %></span>
          </div>
          <div class="widget__body">
            <div class="acct">
              <div class="acct__row">
                <span class="acct__label"><%= _lcs( 'Gesamt' ) %></span>
                <span class="acct__value" data-id="ai-total">—</span>
              </div>
              <div class="acct" data-id="ai-months"></div>
              <div class="acct__legend">
                <span data-id="ai-requests">—</span>
                <span><%= _lcs( 'Schätzung nach Listenpreis' ) %></span>
              </div>
              <p class="ai-cost__warn" data-id="ai-unpriced" hidden>
                <i class="icon icon--triangle-alert"></i> <span></span>
              </p>
            </div>
          </div>
        </div>

      </div>

    </section>

  </div>

</div>
